import React from 'react';
import { useTranslation } from 'react-i18next';
import { Select } from '@chapche/ui';

const PreferenceStructureIncluded = ({ itemSaveService }) => {
    const { i18n } = useTranslation();
    const updatePreferenceValue = (value) => {
        itemSaveService.updatePreferenceProperty('include', value);
    };
    const createListOfOptions = () => {
        return [
            {
                label: i18n.t('preference.scheme.include.true'),
                value: true,
            },
            {
                label: i18n.t('preference.scheme.include.false'),
                value: false,
            },
        ];
    };
    return (
        <label className="block__text preference__form-label">
            <span>{i18n.t('app.page.preference.addTitles.include')}</span>
            <Select
                fullWidth
                className="mt-0"
                value={itemSaveService.getPreference()?.include}
                options={createListOfOptions()}
                onChange={updatePreferenceValue}
            />
        </label>
    );
};

export default PreferenceStructureIncluded;
